import type { AnchorHTMLAttributes } from 'react';
import styled from 'styled-components';
import classNames from 'classnames';

interface Props {
  scheme?: 'blue' | 'light' | 'dark';
  disabled?: boolean;
  onClick?: AnchorHTMLAttributes<HTMLAnchorElement>['onClick'];
}

const TextLink = styled.a.attrs<Props>(({ disabled, scheme, onClick }) => {
  const textClass = () => {
    if (disabled) return 'text-black-gray cursor-default';
    if (scheme === 'blue') return 'text-blue';
    if (scheme === 'light') return 'text-black-gray hover:text-blue';
    if (scheme === 'dark') return 'text-black-gray hover:text-white';
  };
  const className = classNames(textClass(), {
    'cursor-pointer': !disabled,
  });
  const onClickHandler = (
    e: React.MouseEvent<HTMLAnchorElement, MouseEvent>
  ) => {
    if (disabled) return;
    if (onClick) onClick(e);
  };
  return { className, onClick: onClickHandler };
})<Props>``;

TextLink.defaultProps = {
  scheme: 'blue',
};

export default TextLink;
